import React, { useEffect, useState } from 'react';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { sizeMap, UDImageContainer, UDImageElement, UDImageShape, UDImageSize } from './styles';

export type { UDImageShape, UDImageSize };

export interface UDImageProps {
  url?: string | null;
  /** Картинка, когда ссылки нет или она не загрузилась. По умолчанию — аватар по умолчанию. */
  fallback?: string;
  size?: UDImageSize;
  /** `rounded` — квадрат со скруглением (по умолчанию), `circle` — круг. */
  shape?: UDImageShape;
  className?: string;
}

/**
 * Квадратная картинка заданного размера: аватар, логотип. Нет ссылки или она не загрузилась — `fallback`, а не
 * пустое место: рисуется `<img>`, и по его ошибке загрузки картинка подменяется.
 */
const UDImage = ({ url, fallback = USER_DEFAULT_AVATAR, size = 'md', shape = 'rounded', className }: UDImageProps) => {
  const [isBroken, setIsBroken] = useState(false);

  // Другая ссылка — другая попытка: ошибку прежней с неё не переносим.
  useEffect(() => setIsBroken(false), [url]);

  const src = !url || isBroken ? fallback : url;

  return (
    <UDImageContainer sizePx={sizeMap[size]} shape={shape} className={className} data-shape={shape} data-testid="ud-image">
      <UDImageElement
        src={src}
        alt=""
        data-testid="ud-image-element"
        decoding="async"
        referrerPolicy="no-referrer"
        onError={() => setIsBroken(true)}
      />
    </UDImageContainer>
  );
};

export default UDImage;
